// src/components/Skills.js

import React from 'react';
import "../styles/Skills.css";
import image from '../assets/images/skills/2-cropped.svg'

function Skills() {
  return (
    <div className="skills-section" id="skills">
        <div className="skills-heading-container">
            <h1 id="skills-heading-1">My</h1>
            <h1 id="skills-heading-2">Skills</h1>
        </div>
        <div className="skills-content">
            <img src={image} className="skills-image" alt="" />
            <div className="skills-text">
                <div className="skill-category">
                    <h2>Technical Skills</h2>
                        <ul>
                            <li><strong>Programming:</strong> Java, C, JavaScript</li>
                            <li><strong>Web Development:</strong> React, Node.js, HTML, CSS</li>
                            <li><strong>Systems:</strong> Linux, CLI</li>
                            <li><strong>Tools:</strong> Git</li>
                            <li><strong>Foundations:</strong> Secure Coding Principles, Client-Server Architecture, Multithreading Fundamentals</li>
                    </ul>
                </div>
                <div className="skill-category">
                    <h2>Design & UX</h2>
                    <ul>
                        <li><strong>UX:</strong> User Research, Wireframing, Prototyping, Web Accessibility</li>
                        <li><strong>Tools:</strong> Figma, Adobe Creative Suite</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Skills;
